/** The services piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { ServicesEvents } from './contract';
import { ServicesView } from './ServicesView';
import { useServices } from './useServices';

export function Services(props: PieceInput<ServicesEvents>) {
  return <ServicesView {...useServices(props)} />;
}
